module.exports = __webpack_public_path__ + "assets/05b6ce46d41a7681bd41ff45f01bdfab.mp3";